import { IPomReportingTableData } from "../../components/reporting-table/pom-reporting-table-data";

const QUANTITY_COMPARISON_EPSILON = 1e-9;

const normalizeQuantity = (value: number | undefined | null): number | undefined => {
  if (value === null || value === undefined) {
    return undefined;
  }

  if (Number.isNaN(value)) {
    return undefined;
  }

  return value;
};

export const quantitiesEqual = (left: number | undefined | null, right: number | undefined | null): boolean => {
  const normalizedLeft = normalizeQuantity(left);
  const normalizedRight = normalizeQuantity(right);

  if (normalizedLeft === undefined && normalizedRight === undefined) {
    return true;
  }

  if (normalizedLeft === undefined || normalizedRight === undefined) {
    return false;
  }

  return Math.abs(normalizedLeft - normalizedRight) < QUANTITY_COMPARISON_EPSILON;
};

export const hasPendingChange = (position: IPomReportingTableData): boolean => {
  return position.editedQuantity !== undefined && !quantitiesEqual(position.editedQuantity, position.currentQuantity);
};

export const hasChangesAgainstBaseline = (
  positions: IPomReportingTableData[],
  baselineByPositionNo: Map<number, number>,
): boolean => {
  return positions.some((position) => {
    const currentQuantity = position.editedQuantity ?? position.currentQuantity;
    const baselineQuantity = baselineByPositionNo.get(position.positionNo) ?? position.currentQuantity;

    return !quantitiesEqual(currentQuantity, baselineQuantity);
  });
};
